/**
 * bazaarvoice-consent-controller.js
 * Bridges Shopify's Customer Privacy API to Bazaarvoice's cookie consent API.
 * BV's Shopify app does not read Shopify consent, so this is the only link.
 * Inert until Cookie Opt-In is enabled in the BV Configuration Hub.
 */
(function () {
  'use strict';

  const BV_OPTIONAL_COOKIES = ['bv_metrics', 'BVBRANDID', 'BVBRANDSID'];
  const BV_POLL_INTERVAL_MS = 200;
  const BV_POLL_TIMEOUT_MS = 10000;

  const state = { desired: null };

  function bvReady() {
    return typeof window.BV?.cookieConsent?.setConsent === 'function';
  }

  /* bv.js is async and exposes no ready event, so poll within a bounded window. */
  function whenBvReady(callback) {
    if (bvReady()) {
      callback();
      return;
    }
    const startedAt = performance.now();
    const timer = setInterval(function () {
      if (bvReady()) {
        clearInterval(timer);
        callback();
        return;
      }
      if (performance.now() - startedAt > BV_POLL_TIMEOUT_MS) clearInterval(timer);
    }, BV_POLL_INTERVAL_MS);
  }

  function pushConsent(granted) {
    if (granted === state.desired) return;
    state.desired = granted;
    whenBvReady(function () {
      const payload = {};
      BV_OPTIONAL_COOKIES.forEach(function (name) {
        payload[name] = state.desired;
      });
      window.BV.cookieConsent.setConsent(payload);
    });
  }

  /* BV labels these three Performance / Analytical, so gate on analytics
     rather than the broader userCanBeTracked(). */
  function resolveConsent(privacy) {
    return privacy.analyticsProcessingAllowed();
  }

  function sync() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    pushConsent(resolveConsent(privacy) === true);
  }

  function init() {
    document.addEventListener('visitorConsentCollected', sync);
    if (window.Shopify?.customerPrivacy) {
      sync();
      return;
    }
    window.Shopify?.loadFeatures?.(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) sync();
      }
    );
  }

  document.addEventListener('DOMContentLoaded', init);
})();
